import { configureStore } from '@reduxjs/toolkit';
import appStore from './app-store';

export const store = configureStore({
  reducer: {
    app: appStore.reducer,
  },
});
